import { Badge } from 'framework7-react';
import { FC } from 'react';

import { useAnalytics } from '@hooks/useAnalytics';

import { useNavigate } from '@router/index';

import { FontAwesomeIcon } from '@components/icons/FontAwesomeIcon';

const PRIMARY_CTA_CARD_WIDTH = 36;

export const PrimaryCtaCard: FC<{
  variant?: 'default' | 'dashed';
  cta: {
    img: string;
    title: string;
    description: string;
    url: string;
    badgeCount?: number;
    onClick?: () => void;
  };
  track: {
    event: string | undefined;
    properties?: Record<string, any>;
  };
}> = ({ variant = 'default', cta, track: trackProperties }) => {
  const { track } = useAnalytics();
  const navigate = useNavigate();

  const handleClick = () => {
    if (trackProperties?.event) {
      track(trackProperties.event, { ...(trackProperties.properties ?? {}), cta });
    }

    if (cta.onClick) {
      cta.onClick();
      return;
    }

    if (cta.url) {
      navigate(cta.url);
    }
  };

  return (
    <div
      className="d-flex align-items-center gap-3 py-2 px-3"
      style={{
        background: variant === 'default' ? 'rgba(255,255,255,.1)' : 'rgba(255,255,255,.075)',
        border: variant === 'default' ? 'none' : '1px dashed rgba(255,255,255,.15)',
        borderRadius: 8,
        position: 'relative',
      }}
      onClick={handleClick}
    >
      {!!cta.badgeCount && (
        <div style={{ position: 'absolute', right: -8, top: -8 }}>
          <Badge color="red">{cta.badgeCount}</Badge>
        </div>
      )}
      <div className="d-flex align-items-center" style={{ width: PRIMARY_CTA_CARD_WIDTH }}>
        <img
          src={cta.img}
          width={PRIMARY_CTA_CARD_WIDTH}
          style={{ height: 'auto', borderRadius: 4, overflow: 'hidden' }}
        />
      </div>
      <div className="d-flex align-items-center justify-content-between w-100 gap-3">
        <div className="d-grid">
          <strong>{cta.title}</strong>
          <span style={{ opacity: 0.75, lineHeight: 1.3, fontSize: '.8rem' }}>
            {cta.description}
          </span>
        </div>
        {cta.url && <FontAwesomeIcon name="chevron-right" />}
      </div>
    </div>
  );
};
